import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Icon, ButtonMenu } from "@ann/web-components";
import { HeaderContainer, TitleContainer, IconWrapper } from "./Header.styled";
import { resetPassword } from "../../../../services";
import { useToast } from "../../../../../../../components/toast";

const Header = ({ title, email }) => {
  const navigate = useNavigate();
  const [isResetting, setIsResetting] = useState(false);
  const toast = useToast();

  const handleBackClick = () => {
    navigate("/v2/user-management");
  };

  const handleMenuChange = async (value) => {
    if (value === "reset_password") {
      if (!email) {
        toast.error({
          message: "Email is required to reset password",
          canClose: true,
        });
        return;
      }

      setIsResetting(true);
      try {
        const response = await resetPassword(email);
        
        let successMessage = "Password reset code sent successfully";
        
        if (response?.msgCode && Array.isArray(response.msgCode) && response.msgCode.length > 0) {
          successMessage = response.msgCode[0].description || successMessage;
        }
        
        toast.success({
          message: successMessage,
          canClose: true,
        });
      } catch (error) {
        let errorMessage = "Failed to reset password";
        
        if (error?.response?.data) {
          const errorData = error.response.data;
          if (errorData.msgCode && Array.isArray(errorData.msgCode) && errorData.msgCode.length > 0) {
            errorMessage = errorData.msgCode[0].description || errorData.msgCode[0].code || errorMessage;
          } else if (errorData.message) {
            errorMessage = errorData.message;
          }
        } else if (error?.message) {
          errorMessage = error.message;
        }
        
        toast.error({
          message: errorMessage,
          canClose: true,
        });
      } finally {
        setIsResetting(false);
      }
    } else if (value === "activate_user") {
      console.log("Activate user action");
    }
  };

  return (
    <HeaderContainer>
      <TitleContainer>
        <IconWrapper onClick={handleBackClick}>
          <Icon name="arrowLeft" size="medium" />
        </IconWrapper>
        {title && (
          <Typography category="title" size="large" weight="bold">
            {title}
          </Typography>
        )}
      </TitleContainer>

      <ButtonMenu
        iconPosition="right"
        label="Actions"
        menuPosition="bottom"
        onChange={handleMenuChange}
        size="medium"
        type="primary"
        width="auto"
        disabled={isResetting}
      >
        <ButtonMenu.Menu>
          <ButtonMenu.Item
            label="Activate User"
            value="activate_user"
          >
            Activate User
          </ButtonMenu.Item>
          <ButtonMenu.Item
            label="Reset Password"
            value="reset_password"
          >
            Reset Password
          </ButtonMenu.Item>
        </ButtonMenu.Menu>
      </ButtonMenu>
    </HeaderContainer>
  );
};

export default Header;

